import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import "./App.css";
import AutoExpandingTextArea from "./Components/AutoExpandingTextArea.tsx";

interface PublicPlayerData {
  sessionId: string;
  name: string;
  charCount: number;
  hasSubmittedInstructions: boolean;
}

interface AIRoomNameEntryProps {
  roomName: string;
  sessionId: string;
  socket: any;
  setAIRoomState: (state: string) => void;
  setRoomState: (state: string) => void;
  players: PublicPlayerData[];
  showInfoMessage: (
    type: string,
    message: string,
    isAdd: boolean,
    duration?: string,
    isDelay?: boolean,
  ) => void;
  isEdit?: boolean;
}

function AIRoomNameEntry({
  roomName,
  sessionId,
  socket,
  setAIRoomState,
  setRoomState,
  players,
  showInfoMessage,
  isEdit = false,
}: AIRoomNameEntryProps) {
  const { t } = useTranslation();
  const [nameInput, setNameInput] = useState("");
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  // If this session already has a name (reconnection), skip to lobby
  if (!isEdit) {
    const existingPlayer = players.find((p) => p.sessionId === sessionId);
    if (existingPlayer && existingPlayer.name) {
      setTimeout(() => setAIRoomState("lobby"), 0);
      return null;
    }
  }

  const submitName = () => {
    const name = nameInput.trim();
    if (!name) {
      showInfoMessage("warning", "Skriv inn navnet ditt", false);
      return;
    }
    if (isEdit) {
      socket.emit("ai room update name", { roomName, sessionId, name });
      setAIRoomState("lobby");
    } else {
      socket.emit("ai room join", { roomName, sessionId, name });
      setAIRoomState("instructions");
    }
  };

  return (
    <div className="App-header">
      <div className="container-row lift-topbar">
        <div className="container-row-start">
          <div
            className="button-tertiary-m button-text-m text-color-black"
            onClick={() =>
              isEdit ? setAIRoomState("lobby") : setRoomState("start screen")
            }
            style={{ maxHeight: "32.5px" }}
          >
            {t("back")}
          </div>
        </div>
        <div className="text-h3 text-color-black left-margin-s text-force-break">
          {roomName}
        </div>
      </div>

      <div
        className="App-header"
        style={{ justifyContent: "flex-end", gap: 0 }}
      >
        <div style={{ marginTop: 32 }}>
          <p className="text-h2 text-color-black" style={{ marginBottom: 24 }}>
            {isEdit ? "ENDRE NAVN" : "HVEM ER DU?"}
          </p>
        </div>

        <div style={{ flex: "1 1 auto" }} />

        <div className="container">
          <AutoExpandingTextArea
            value={nameInput}
            onChange={setNameInput}
            textareaRef={textAreaRef}
            placeholder={"SKRIV NAVN..."}
            maxLength={20}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                submitName();
              }
            }}
          />
        </div>
      </div>

      <div
        className="button-primary black-fill button-text-l text-color-pink shadow-pink box-button-center"
        onClick={submitName}
      >
        {isEdit ? "LAGRE" : "NESTE"}
      </div>
    </div>
  );
}

export default AIRoomNameEntry;
